import * as React from "react";
import { useState, useEffect, useCallback } from "react";
import { useFormikContext, useField } from "formik";
import { PasswordInput } from "security-app/components/common";
export const buildPasswordValue = (rawValue, hasPassword) => {
  if (rawValue === "" && !hasPassword) return null;
  return rawValue === "" && hasPassword ? { delete_value: true } : { set_value: rawValue };
};
function FormikPasswordInput({ field, label, action, placeholder, help, required, disabled, hasPassword }) {
  var _a, _b, _c;
  const [_f, { touched, error }] = useField({ name: field.name });
  const { setFieldValue, setFieldTouched } = useFormikContext();
  const [localValue, setLocalValue] = useState(
    ((_a = field.value) == null ? void 0 : _a.keep_value) || ((_b = field.value) == null ? void 0 : _b.is_set) || ((_c = field.value) == null ? void 0 : _c.set_value) || ""
  );
  useEffect(() => {
    var _a2, _b2;
    if (((_a2 = field.value) == null ? void 0 : _a2.is_set) === true) {
      setFieldValue(field.name, { keep_value: true });
    } else if (((_b2 = field.value) == null ? void 0 : _b2.is_set) === false) {
      setFieldValue(field.name, null);
    }
  }, [field.name, field.value, setFieldValue]);
  const updateValue = (e) => {
    const { target } = e;
    setLocalValue(target.value);
    setFieldTouched(target.name, true);
    field.onChange({
      ...e,
      target: {
        ...target,
        name: field.name,
        value: typeof target.value === "boolean" ? { keep_value: target.value } : buildPasswordValue(target.value, hasPassword)
      }
    });
  };
  const onResetValue = useCallback(() => {
    setLocalValue("");
    setFieldValue(field.name, buildPasswordValue("", hasPassword));
    setFieldTouched(field.name, true);
  }, [field.name, hasPassword, setFieldTouched, setFieldValue]);
  const onCancelResetValue = useCallback(() => {
    setFieldValue(field.name, { keep_value: hasPassword });
  }, [setFieldValue, field.name, hasPassword]);
  return /* @__PURE__ */ React.createElement(
    PasswordInput,
    {
      name: field.name,
      label,
      action,
      placeholder,
      value: localValue,
      help: touched && !!error ? null : help,
      error: touched && !!error ? error : "",
      onChange: updateValue,
      onBlur: updateValue,
      onResetPassword: onResetValue,
      onCancelReset: onCancelResetValue,
      hasPassword,
      required,
      disabled
    }
  );
}
export default FormikPasswordInput;
